"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHeaderLinkDefaultProps = exports.PageHeaderDefaultProps = exports.PageHeaderButtonDefaultProps = exports.PAGE_HEADER_LINK_SELECTION_INDICATOR_HEIGHT = void 0;

var _interfaces = require("./interfaces");

var PageHeaderDefaultProps = {
  colorScheme: _interfaces.PageHeaderColorScheme.Default,
  isFullWidth: false,
  hasShadow: false,
  isFixed: false,
  top: 0
};
exports.PageHeaderDefaultProps = PageHeaderDefaultProps;
var PageHeaderButtonDefaultProps = {
  paddingHorizontal: 'S300',
  hasHover: true
};
exports.PageHeaderButtonDefaultProps = PageHeaderButtonDefaultProps;
var PageHeaderLinkDefaultProps = {
  paddingHorizontal: 'S300',
  hasHover: true,
  isSelected: false
};
exports.PageHeaderLinkDefaultProps = PageHeaderLinkDefaultProps;
var PAGE_HEADER_LINK_SELECTION_INDICATOR_HEIGHT = 4;
exports.PAGE_HEADER_LINK_SELECTION_INDICATOR_HEIGHT = PAGE_HEADER_LINK_SELECTION_INDICATOR_HEIGHT;